import React, { Component, createRef } from "react";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import "react-international-phone/build/index.css";
import PageTitle from "../ExtraComponents/PageTitle";
import {
  getAgentTwilioVerification,
  getAgentTwilioVerificationData,
  deleteAgentTwilioNumber,
} from "../../../config/agent_forms_api_calls";
import HelperClass from "./../../../config/helperClass";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import parsePhoneNumberFromString from "libphonenumber-js";
import $ from "jquery"; // ✅ for modal handling

const auth = new HelperClass();

class TwilioImportForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      tableLoader: true,
      phone: "",
      accountSID: "",
      authToken: "",
      label: "",
      smsEnabled: true,
      errorPhone: false,
      errorMessage: "",
      successMessage: "",
      twilioLoader: false,
      deleteTargetSid: "",
      deleteLoader: false,
      showAuthToken: false,
      mobileActionMenuOpen: false,

      columnServices: [
        { name: "Date Added" },
        {
          name: "Phone Number",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.formatPhoneNumber(value)}</div>;
            },
          },
        },
        { name: "Phone SID" },
        {
          name: "Region",
          options: {
            customBodyRender: (value) => {
              if (!value) return "-";
              return value.charAt(0).toUpperCase() + value.slice(1);
            },
          },
        },
        {
          name: "SMS Enabled",
          options: {
            customBodyRender: (value, tableMeta) => (
              <div>{this.defaultText(value, tableMeta)}</div>
            ),
          },
        },
        {
          name: "Voice Enabled",
          options: {
            customBodyRender: (value, tableMeta) => (
              <div>{this.defaultText(value, tableMeta)}</div>
            ),
          },
        },
        {
          name: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const sid = tableMeta.rowData[2];
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ paddingTop: "0px", paddingBottom: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            href="#"
                            title="Other Actions"
                            className="dropdown-toggle btn btn-icon  btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  onClick={() => this.openDeleteModal(sid)}
                                  title="Delete Number"
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                      this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-trash"></em>
                                  <span>Delete</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],
    };

    this.phoneInputRef = createRef();
    this.mobileActionsRef = createRef();
  }

  async componentDidMount() {
    await this.fetchTwilioNumbers();
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  defaultText = (value, tableMeta) => {
    // Convert string "1"/"0" or boolean to number
    const numValue = Number(value);

    if (numValue === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-check"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-cross"></em> No
        </span>
      );
    }
  };

  // ✅ Fetch Numbers from DB
  fetchTwilioNumbers = async () => {
    this.setState({ tableLoader: true });
    const response = await getAgentTwilioVerificationData(
      auth.getAccount(),
      auth.getToken()
    );

    if (
      response.data.status === 403 ||
      response.data.errors === "authentication missing" ||
      response.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      response.data.status === 200 &&
      response.data.message === "success"
    ) {
      const formattedData = response.data.data.map((item) => [
        item.created_at,
        item.phone_number,
        item.sid,
        item.region,
        item.sms_enabled,
        item.voice_enabled,
      ]);
      this.setState({ tableData: formattedData, tableLoader: false });
    } else {
      this.setState({ tableLoader: false });
    }
  };

  // ✅ Handle Input Change
  handleChange = (eOrField, value) => {
    if (typeof eOrField === "object" && eOrField.target) {
      const { name, value } = eOrField.target;
      this.setState({ [name]: value });
    } else if (typeof eOrField === "string") {
      this.setState({ [eOrField]: value });
    } else {
      this.setState({ phone: value });
    }
  };

  handleFocus = () => {
    const input = this.phoneInputRef.current?.inputRef?.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  autoHideMessages = () => {
    setTimeout(() => {
      this.setState({
        errorMessage: "",
        successMessage: "",
      });
    }, 4000); // hide after 4 seconds
  };

  handleSubmit = async () => {
    const accountSID = (this.state.accountSID || "").trim();
    const authToken = (this.state.authToken || "").trim();
    const phone = (this.state.phone || "").trim();

    if (!accountSID || !authToken || !phone) {
      this.setState({
        twilioLoader: false,
        errorMessage: "Please fill all required fields before importing.",
        successMessage: "",
      });
      this.autoHideMessages();
      return;
    }

    this.setState({ twilioLoader: true, errorMessage: "", successMessage: "" });

    try {
      const response = await getAgentTwilioVerification(
        auth.getAccount(),
        auth.getToken(),
        accountSID,
        authToken,
        phone
      );
      const res = response.data;

      if (
        res.status === 403 ||
        res.errors === "authentication missing" ||
        res.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      }

      if (res.status === 404) {
        this.setState({
          twilioLoader: false,
          errorMessage: "Twilio account not found or invalid credentials.",
        });
        this.autoHideMessages();
        return;
      }

      if (res.status === 409) {
        this.setState({
          twilioLoader: false,
          errorMessage: res.message || "This Twilio number already exists.",
        });
        this.autoHideMessages();
        return;
      }

      if (res.status === 200 && res.message === "success") {
        this.setState({
          twilioLoader: false,
          successMessage: "Twilio data imported successfully.",
          errorMessage: "",
        });

        // Close after 2s, then refresh
        setTimeout(async () => {
          window.$("#modalAddTwilio").modal("hide");
          this.setState({
            successMessage: "",
            accountSID: "",
            authToken: "",
            phone: "",
          });
          await this.fetchTwilioNumbers();
        }, 2000);
        return;
      }

      this.setState({
        twilioLoader: false,
        errorMessage:
          res.message || "Unexpected server response. Please try again.",
      });
    } catch (err) {
      this.setState({
        twilioLoader: false,
        errorMessage:
          err.response?.data?.message ||
          "A network or server error occurred. Please try again.",
      });
    }
  };

  cancelDelete = () => {
    this.setState({ deleteTargetSid: "" });
    window.$("#modalDeleteTwilio").modal("hide");
  };

  openDeleteModal = (sid) => {
    this.setState({
      deleteTargetSid: sid,
      successMessage: "",
      errorMessage: "",
    });
    window.$("#modalDeleteTwilio").modal("show");
  };

  confirmDelete = async () => {
    const { deleteTargetSid } = this.state;

    if (!deleteTargetSid) return;

    this.setState({ deleteLoader: true, successMessage: "", errorMessage: "" });

    try {
      const response = await deleteAgentTwilioNumber(
        auth.getAccount(),
        auth.getToken(),
        deleteTargetSid
      );

      const res = response.data;

      if (res.status === 200) {
        this.setState({
          deleteLoader: false,
          successMessage: "Twilio number deleted successfully.",
          errorMessage: "",
        });

        setTimeout(() => {
          window.$("#modalDeleteTwilio").modal("hide");
          window.location.reload(); // 🔁 Force full page refresh
        }, 1500);
      } else {
        this.setState({
          deleteLoader: false,
          errorMessage: res.message || "Failed to delete number.",
          successMessage: "",
        });
      }
    } catch (err) {
      console.error("Delete Error:", err);
      this.setState({
        deleteLoader: false,
        errorMessage:
          err.response?.data?.message ||
          "A server error occurred while deleting.",
        successMessage: "",
      });
    }
  };

  openAddTwilioModal = () => {
    // clear controlled inputs + messages
    this.setState({
      accountSID: "",
      authToken: "",
      phone: "",
      smsEnabled: true,
      errorMessage: "",
      successMessage: "",
      twilioLoader: false,
    });

    // open the modal
    window.$("#modalAddTwilio").modal("show");

    // after it mounts, hard-disable browser autofill suggestions
    setTimeout(() => {
      const $modal = window.$("#modalAddTwilio");
      $modal.find("input").attr({
        autocomplete: "off",
        autocapitalize: "off",
        autocorrect: "off",
        spellcheck: "false",
      });
      // Give the inputs "new-" style names to further avoid autofill heuristics
      $modal
        .find('input[name="twilio_sid_input"]')
        .attr("name", "new-twilio-sid");
      $modal
        .find('input[name="twilio_auth_input"]')
        .attr("name", "new-twilio-token");
    }, 0);
  };

  toggleMobileActionMenu = (e) => {
    e.preventDefault();
    this.setState((prev) => ({
      mobileActionMenuOpen: !prev.mobileActionMenuOpen,
    }));
  };

  closeMobileActionMenu = () => {
    this.setState({ mobileActionMenuOpen: false });
  };

  handleOutsideClick = (e) => {
    if (
      this.mobileActionsRef.current &&
      !this.mobileActionsRef.current.contains(e.target) &&
      this.state.mobileActionMenuOpen
    ) {
      this.closeMobileActionMenu();
    }
  };

  render() {
    const { phone, accountSID, authToken, smsEnabled, errorPhone } = this.state;

    return (
      <div className="nk-content" id="Support_Block">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE HEADER */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Phone Numbers" icon="icon ni ni-call" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content phone-number-head-actions">
                    <div className="d-none d-md-flex">
                      <a
                        className="btn btn-primary mr-2"
                        style={{
                          color: "white",
                        }}
                        onClick={this.openAddTwilioModal}
                      >
                        <em className="icon ni ni-plus-round"></em>&nbsp;Add New
                        Number
                      </a>
                      <a
                        className="btn btn-primary"
                        href="phone_number/buy_number"
                      >
                        <em className="icon ni ni-plus-round"></em>&nbsp;Buy a
                        Number
                      </a>
                    </div>

                    <div
                      className="d-md-none phone-number-mobile-actions"
                      ref={this.mobileActionsRef}
                    >
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger"
                        onClick={this.toggleMobileActionMenu}
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>

                      {this.state.mobileActionMenuOpen ? (
                        <div className="phone-number-mobile-actions-menu">
                          <a
                            className="btn btn-primary"
                            style={{ color: "white" }}
                            onClick={() => {
                              this.openAddTwilioModal();
                              this.closeMobileActionMenu();
                            }}
                          >
                            <em className="icon ni ni-plus-round"></em>&nbsp;Add
                            New Number
                          </a>
                          <a
                            className="btn btn-primary"
                            href="phone_number/buy_number"
                            onClick={this.closeMobileActionMenu}
                          >
                            <em className="icon ni ni-plus-round"></em>&nbsp;Buy
                            a Number
                          </a>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>

              {/* DATATABLE */}
              <div className="nk-block">
                <div className="row">
                  <div className="col-md-12">
                    {this.state.tableLoader ? (
                      tableLoader()
                    ) : (
                      <DataTable
                        columns={this.state.columnServices}
                        tableData={this.state.tableData}
                        title="Phone Numbers"
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* ✅ BOOTSTRAP MODAL */}
              <div className="modal fade" tabIndex="-1" id="modalAddTwilio">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em
                          className="icon ni ni-call"
                          style={{ marginRight: "5px" }}
                        ></em>
                        Add Twilio Number
                      </h5>
                    </div>
                    <div className="modal-body">
                      <div className="row g-4">
                        {/* ERROR / SUCCESS ALERTS */}
                        {this.state.errorMessage && (
                          <div className="col-md-12 mb-1">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {this.state.successMessage && (
                          <div className="col-md-12 mb-1">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* FORM START */}
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="form-label">
                              Twilio Phone Number *
                            </label>
                            <ReactPhoneInput
                              country={"us"}
                              value={this.state.phone}
                              onChange={(value) => this.handleChange("phone", value)}
                              inputProps={{
                                name: "phone",
                                id: "phone",
                                required: true,
                                maxLength: 20,
                              }}
                              inputClass={
                                this.state.errorPhone ? "error-border" : "default-border"
                              }
                              containerStyle={{ width: "100%" }}
                              inputStyle={{ width: "100%", minHeight: "50px" }}
                              specialLabel=""
                              onFocus={this.handleFocus}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="form-label">
                              Twilio Account SID *
                            </label>
                            <input
                              type="text"
                              className="form-control twilio-input"
                              value={this.state.accountSID}
                              onChange={(e) =>
                                this.handleChange("accountSID", e.target.value)
                              }
                              placeholder="Twilio Account SID"
                              name="twilio_sid_input" // will be renamed to new-twilio-sid on open
                              autoComplete="off"
                              autoCapitalize="off"
                              autoCorrect="off"
                              spellCheck={false}
                            />
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group position-relative">
                            <label className="form-label">
                              Twilio Auth Token *
                            </label>
                            <input
                              type={
                                this.state.showAuthToken ? "text" : "password"
                              }
                              className="form-control twilio-input"
                              value={this.state.authToken}
                              onChange={(e) =>
                                this.handleChange("authToken", e.target.value)
                              }
                              placeholder="Twilio Auth Token"
                              name="twilio_auth_input"
                              autoComplete="new-password"
                              autoCapitalize="off"
                              autoCorrect="off"
                              spellCheck={false}
                              style={{ paddingRight: "40px" }}
                            />
                            <em
                              className={`icon ni ${this.state.showAuthToken
                                  ? "ni-eye-off"
                                  : "ni-eye"
                                }`}
                              onClick={() =>
                                this.setState({
                                  showAuthToken: !this.state.showAuthToken,
                                })
                              }
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "48px",
                                cursor: "pointer",
                                color: "#8094ae",
                                fontSize: "1.1rem",
                              }}
                              title={
                                this.state.showAuthToken
                                  ? "Hide Token"
                                  : "Show Token"
                              }
                            ></em>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div
                            className="card bg-lighter border"
                            style={{
                              borderRadius: "4px",
                              padding: "1rem 1.25rem",
                              marginBottom: "2rem",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div
                                  style={{
                                    fontSize: "0.875rem",
                                    fontWeight: 500,
                                    color: "#364a63",
                                    marginBottom: "0.25rem",
                                  }}
                                >
                                  SMS Enabled
                                </div>
                                <div
                                  style={{
                                    fontSize: "0.8125rem",
                                    color: "#8094ae",
                                  }}
                                >
                                  Enable SMS messaging for this phone number
                                </div>
                              </div>
                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="smsEnabledSwitch"
                                  checked={this.state.smsEnabled}
                                  onChange={(e) =>
                                    this.setState({
                                      smsEnabled: e.target.checked,
                                    })
                                  }
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="smsEnabledSwitch"
                                ></label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ACTION BUTTONS */}
                        <div
                          className="col-md-12 d-flex justify-content-end"
                          style={{
                            borderTop: "1px solid #e5e9f2",
                            paddingTop: "1rem",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() =>
                              window.$("#modalAddTwilio").modal("hide")
                            }
                          >
                            <em className="icon ni ni-cross"></em>
                            &nbsp;Close
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary ml-2"
                            onClick={this.handleSubmit}
                            disabled={this.state.twilioLoader}
                          >
                            {this.state.twilioLoader ? (
                              <>
                                <em className="icon ni ni-loader animate-spin"></em>
                                &nbsp;Importing...
                              </>
                            ) : (
                              <>
                                <em className="icon ni ni-import"></em>
                                &nbsp;Import from Twilio
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END MODAL */}
              <div className="modal fade" tabIndex="-1" id="modalDeleteTwilio">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.cancelDelete();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>

                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>

                        <h4 className="nk-modal-title">
                          Do you want to delete this Twilio number?
                        </h4>

                        <div className="nk-modal-text">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>

                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.cancelDelete();
                            }}
                          >
                            CANCEL
                          </a>{" "}
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.confirmDelete();
                            }}
                            disabled={this.state.deleteLoader}
                          >
                            {this.state.deleteLoader ? (
                              <span>DELETING...</span>
                            ) : (
                              <span>DELETE</span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TwilioImportForm;
